// removed by extract-text-webpack-plugin
module.exports = {"overwrite":"tooltip__overwrite___1QBIf"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/tooltip.css
// module id = 842
// module chunks = 0